import { Component, Input, OnInit } from '@angular/core';
import { IDashboardMidwifePayload, ITestimonialBody, ITestimonialResponse } from 'src/app/models/dashboard.models';
import { DashboardService } from 'src/app/services/dashboard.service';
declare var $: any;
@Component({
  selector: 'app-write-testimonial',
  templateUrl: './write-testimonial.component.html',
  styleUrls: ['./write-testimonial.component.scss']
})
export class WriteTestimonialComponent implements OnInit {

  testimonial: string = '';
  @Input() midwife: IDashboardMidwifePayload;

  constructor(public dashboardService: DashboardService) { }

  ngOnInit(): void {
  }

  createTestimonial(){
    let body: ITestimonialBody={
      midwifeId: this.midwife.midwifeId,
      testimonial: this.testimonial
    }

    this.dashboardService.createTestimonial(body)
    .subscribe((res: ITestimonialResponse)=>{
      console.log("Testimonial Created: ",res);
      $('#write-testimonial').modal('hide');
      this.clearData();
    },err=>{
      console.error(err);
    });
  }

  clearData(){
    this.testimonial = '';
  }

}
